"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelector = void 0;
const Block_1 = require("./Block");
const pixi_js_1 = require("pixi.js");
const Global_1 = require("../Global");
const ui_1 = require("@pixi/ui");
const i18next_1 = __importDefault(require("i18next"));
const config_json_1 = __importDefault(require("../../../shared/config.json"));
const settings_1 = require("../config/settings");
const AssetManager_1 = __importDefault(require("../managers/AssetManager"));
class LanguageSelector extends Block_1.Block {
    constructor(app) {
        super(app);
        this._onChange = null;
        this.select = this.makeSelector();
    }
    set onChange(changer) {
        this._onChange = changer;
    }
    makeSelector() {
        const scale = 34;
        const clearbg = 'rgba(255, 255, 255, 0.0001)';
        const langs = config_json_1.default.langs;
        const arrowstyle = new pixi_js_1.TextStyle({
            fontWeight: 'lighter',
            fontFamily: 'Arial',
            fontSize: (0, Global_1.px)(scale + 6)
        });
        // Trick to make it look "transparent"
        const closed = this.makeBox({
            backgroundColor: settings_1.Settings.whiteColor,
            border: 2,
            height: scale + 8,
            width: 150,
            radius: 5
        });
        const arrowtext = new pixi_js_1.Text('›', arrowstyle);
        arrowtext.anchor.set(0.5);
        arrowtext.rotation = Math.PI / 2;
        arrowtext.position.set(closed.width - (0, Global_1.px)(12), closed.height / 2);
        closed.addChild(arrowtext);
        const open = this.makeBox({
            backgroundColor: settings_1.Settings.whiteColor,
            border: 2,
            height: (closed.height / (0, Global_1.px)()) * Math.min(langs.length + 1, 5),
            width: 150,
            radius: 5
        });
        const invertarrowtext = new pixi_js_1.Text('›', arrowstyle);
        invertarrowtext.anchor.set(0.5);
        invertarrowtext.rotation = -Math.PI / 2;
        invertarrowtext.position.set(open.width - (0, Global_1.px)(18), closed.height / 2);
        open.addChild(invertarrowtext);
        const hstyle = Block_1.Block.textStyle(scale - 2);
        hstyle.align = 'left';
        const istyle = Block_1.Block.textStyle(scale - 6);
        istyle.align = 'left';
        const select = new ui_1.Select({
            closedBG: closed,
            openBG: open,
            textStyle: hstyle,
            selected: langs.indexOf(i18next_1.default.language) || 0,
            selectedTextOffset: { x: (0, Global_1.px)(-15), y: (0, Global_1.px)(2) },
            scrollBox: {
                width: open.width,
                height: open.height - closed.height - (0, Global_1.px)(2),
                radius: (0, Global_1.px)(5),
            },
            items: {
                items: langs.map(l => {
                    if (settings_1.LanguageMap[l]) {
                        return settings_1.LanguageMap[l];
                    }
                    return l.toUpperCase();
                }),
                backgroundColor: clearbg,
                radius: 0,
                textStyle: istyle,
                width: open.width,
                height: closed.height - (0, Global_1.px)(6)
            }
        });
        this.sigs.push(select.onSelect.connect((item) => {
            if (this._onChange && langs[item]) {
                AssetManager_1.default.tickSound();
                this._onChange(langs[item]);
            }
        }));
        return this.addChild(select);
    }
}
exports.LanguageSelector = LanguageSelector;
